'use strict';

var multiaddr = require('multiaddr');

var errCode = require('err-code');

var _require = require('ip-address'),
    Address4 = _require.Address4,
    Address6 = _require.Address6;

var errors = {
  ERR_INVALID_IP_PARAMETER: 'ERR_INVALID_IP_PARAMETER',
  ERR_INVALID_PORT_PARAMETER: 'ERR_INVALID_PORT_PARAMETER',
  ERR_INVALID_IP: 'ERR_INVALID_IP'
};

module.exports = function (ip, port) {
  if (typeof ip !== 'string') {
    throw errCode(new Error("invalid ip provided: ".concat(ip)), errors.ERR_INVALID_IP_PARAMETER);
  }

  port = parseInt(port);

  if (isNaN(port)) {
    throw errCode(new Error("invalid port provided: ".concat(port)), errors.ERR_INVALID_PORT_PARAMETER);
  }

  if (new Address4(ip).isValid()) {
    return multiaddr("/ip4/".concat(ip, "/tcp/").concat(port));
  }

  var ip6 = new Address6(ip);

  if (ip6.isValid()) {
    return ip6.is4() ? multiaddr("/ip4/".concat(ip6.to4().correctForm(), "/tcp/").concat(port)) : multiaddr("/ip6/".concat(ip, "/tcp/").concat(port));
  }

  throw errCode(new Error("invalid ip:port for creating a multiaddr: ".concat(ip, ":").concat(port)), errors.ERR_INVALID_IP);
};

module.exports.Errors = errors;